<template>
  <v-dialog v-model="reportData.dialog"
            width="900" >
     <v-flex xs12 class="cu-trail-class" style="padding:20px 30px">
        <v-layout fill-height class="my-0 chart-layout">
          <v-flex class="py-0 chart-class" v-if="!isLoading">
              <v-layout layout row nowrap justify-space-between style="margin-bottom:15px;">
                <span class="dashboard-title" style="font-weight: 700;font-size: 24px;margin: 0 auto;">QA Test Report</span>
                <!-- <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
                  <span>{{overallScore}}</span>
                  <span>Overall Score</span>
                </div> -->
              </v-layout>
              <v-flex class="test-report-content">
              
                <div class="test-report-card" v-for="(item, index) in testReport" :key="index"> 
                  <div class="test-report-text">
                    <span>{{ item.CatName | formatTitle }}:</span>
                    <span class="score">{{ item.AllScore }} </span>
                  </div>
                  <v-progress-linear class="dashboard-progress"
                    background-color="progress-blue-bg"
                    color="progress-blue-color"
                    height="6"
                    :value="item.AllScore"
                  ></v-progress-linear>
                </div>
              </v-flex>
          </v-flex>
            <v-flex md12 lg12 text-xs-center v-show="isLoading" class="pr-3 pb-4 report-trial-loading progress-loading">
              <v-progress-circular indeterminate :size="50" color="grey"></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-flex>
    </v-dialog>
</template>
<script>
import { getEvaluateList } from '@/api/dashboard'

export default {
    props: {
    reportData: {
      dialog: false
    }
  },
  data: () => ({
    overallScore: 0,
    testReport:[],
    isLoading: false
  }),
  mounted () {
    this.getEvaluateList();
  },
  methods: {
    // 获取QA test report数据
    async getEvaluateList () {
      this.isLoading = true
      await getEvaluateList().then(data => {
        this.overallScore = data.overallScore
        let arr=[]
        if (data.chartsData.length>0) {
           data.chartsData.forEach(item=>{ if(item.CatName!='TESOL'){arr.push(item)}})
           this.testReport =arr
        }else{
          this.testReport = data.chartsData
        } 
        // this.testReport = data.chartsData
        this.isLoading = false;
      });
    },

    show () {
      this.reportData.dialog = true
    }
  
  },
  filters:{
    formatTitle(title){
      return title.replace('Result', '').trim()
    }
  }
}
</script>
<style lang="scss">

.progress-loading{
  margin-top: 100px
}
[data-theme="theme1"] .test-report-content  .test-report-card {
  color: #ececec;
}
[data-theme="theme1"] .test-report-content .test-report-card .dashboard-progress .progress-blue-color{
    background-color: #3253cb !important;
    border-color: #3253cb !important;
}
.test-report-content {
  .test-report-card {
    width: 48%;
    float: left;
    &:nth-child(even) {
      float: right;
    }
    .test-report-text{
      span{
        &.score{
		      @include font_color($font-color-theme);
          margin-left: 3px;
        }
      }
    }
    .dashboard-progress{
      border-radius: 3px;

      .progress-blue-bg{
        background-color: rgba(125, 162, 255, 0.19)!important;
        border-color: rgba(125, 162, 255, 0.19)!important;
      }
      .progress-blue-color{
        background-color: $blue-title-2!important;
        border-color: $blue-title-2!important;
        border-radius: 3px;
      }
    }
  }
}
</style>
